// The start of a tag: `<` or `</`, a name of letters and digits, then whitespace, `/` or `>`.
// Text like `<email@x.com>` or `a < b` does not match.
const HTML_TAG_REGEX = /<\/?[a-z][a-z0-9]*[\s/>]/i
const LINE_BREAK_REGEX = /\r\n|\r|\n/

/**
 * Older documents (e.g. crew notes copied from a template) store plain text with `\n` line breaks
 * and no HTML. `HtmlContent` shows those with `white-space: pre-wrap`, but TipTap's parser (even
 * with `preserveWhitespace: true`) turns every `\n` into a space, so the whole note collapses into
 * one paragraph and is saved that way. Wrap each line in its own `<p>` before it reaches the editor.
 *
 * Content that already has HTML tags, or has no line breaks, is returned unchanged. The text is not
 * escaped: it already holds entities such as `&amp;`, and `HtmlContent` renders it as HTML too.
 */
export function plainTextToHtml(content: string): string
export function plainTextToHtml<T>(content: T): T | string
export function plainTextToHtml<T>(content: T): T | string {
  if (typeof content !== 'string') return content
  if (HTML_TAG_REGEX.test(content) || !LINE_BREAK_REGEX.test(content)) return content

  return content
    .split(LINE_BREAK_REGEX)
    .map((line) => `<p>${line}</p>`)
    .join('')
}
